import { FormattedMessage } from 'react-intl';

import { LocationUtils } from '@arrived/common';
import { FEATURE_FLAGS, useFeature } from '@arrived/feature-flags';
import { Address, Market } from '@arrived/models';

import { PROPERTY_HASH_MAP } from '../Property.constants';
import { PropertyDetailsSection } from './PropertyDetailsSection';

import { DataVizLineGraph, ZillowHomePriceByZipCodeGraph } from '../../charts';

export const PropertyDetailsZillowTrend = ({
  address,
  market,
}: {
  address: Address | undefined;
  market: Market | undefined;
}) => {
  const showZillowPropertyDetailsChart = useFeature<boolean>(FEATURE_FLAGS.SHOW_ZILLOW_PROPERTY_DETAILS_CHART);

  if (!showZillowPropertyDetailsChart.value || !market) return null;

  const { city, province, zipCode } = address || ({} as Address);

  return (
    <PropertyDetailsSection
      hash={PROPERTY_HASH_MAP.realEstate}
      isStacked={true}
      title={
        <FormattedMessage
          id="property-details-real-estate-data-title"
          defaultMessage="Real Estate Data for {location}"
          values={{ location: `${city}, ${LocationUtils.getProvinceShortName(province)}` }}
        />
      }
      description={
        <FormattedMessage
          id="property-details-real-estate-data-description"
          defaultMessage="While no one can predict the future, there is plenty of data available on how property values have performed over the years. The Zillow Home Price indices can be a great tool to understand the past growth in property values for a given market."
        />
      }
    >
      {zipCode && (
        <DataVizLineGraph
          subTitle={
            <FormattedMessage
              id="property-details-real-estate-chart-home-price-subtitle"
              defaultMessage="Single Family Residential 2010-2020 for Zip Code {zipCode}"
              values={{ zipCode }}
            />
          }
          title={
            <FormattedMessage
              id="property-details-real-estate-chart-home-price-title"
              defaultMessage="Zillow Home Price Trends"
            />
          }
        >
          <ZillowHomePriceByZipCodeGraph className="property-details-zillow-graph" zipCode={zipCode} height={375} />
        </DataVizLineGraph>
      )}
    </PropertyDetailsSection>
  );
};
